import React from "react";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface InstagramLinkProps {
  showText?: boolean;
  iconColor?: string;
}

const InstagramLink: React.FC<InstagramLinkProps> = ({
  showText = false,
  iconColor,
}) => {
  const userId = "@lulaendocomunidad";
  const link_msg = "Últimos posts en Instagram";
  const account_link = "https://www.instagram.com/lulaendocomunidad";

  return (
    <a
      href={account_link}
      target="_blank"
      rel="noopener noreferrer"
      title={link_msg}
    >
      <p>
        <FontAwesomeIcon icon={faInstagram} {...(iconColor ? { color: iconColor } : {})} />
      </p>
      {showText && (
        <p>
          <span style={{ color: "#fff" }}>{userId}</span>
        </p>
      )}
    </a>
  );
};

export default InstagramLink;